(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-hero"] && !Shopify.designMode) return;
  try {
    
  class ArticleHeroSection extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('article-hero', ArticleHeroSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const form = document.querySelector('#footer form');
  const inputArea = form.querySelector('.input-area');

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const form = e.target;
    const action = form.getAttribute('action');
    e.submitter.setAttribute('disabled', true);

    $.ajax({
      type: 'POST',
      url: action,
      data: $(form).serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: (error) => {
        console.error(error);
        const size = inputArea.getBoundingClientRect();
        let message = document.createElement('p');
        message.innerText = 'Whoops! Please try again';
        message.style.height = size.height + 'px';
        inputArea.innerHTML = '';
        message.classList.add(
          'flex',
          'items-center',
          'justify-center',
          'text-center',
          'text-[26px]',
          'font-sans',
          'mb-[12px]'
        );
        inputArea.appendChild(message);
      },
      success: (res) => {
        console.log(res);
        const size = inputArea.getBoundingClientRect();
        let message = document.createElement('p');
        message.innerText = 'Thanks!';
        message.style.height = size.height + 'px';
        inputArea.innerHTML = '';
        message.classList.add(
          'flex',
          'items-center',
          'justify-center',
          'text-center',
          'text-[26px]',
          'font-sans',
          'mb-[12px]'
        );
        inputArea.appendChild(message);
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = this.querySelector('#header');
      this.headerBg = this.querySelector('#header-bg');
      this.height = this.querySelector('#header').clientHeight;
      this.animated = this.getAttribute('data-animated') === 'true';
      this.logo = this.querySelector('#header-logo');
      this.logoMobile = this.querySelector('#header-logo-mobile');
      this.menuLogo = this.querySelector('#menu-logo');
      this.desktopNav = this.querySelector('#desktop-nav');
      this.nav_blocks = this.querySelectorAll('.nav-block');
      this.buttons = this.querySelectorAll('.btn');
      this.menuButton = this.querySelector('#mobile-menu-toggle');
      this.mobileMenu = this.querySelector('#mobile-menu');
      this.menuOpen = false;
      this.desktopNav.classList.add('transition-opacity', 'duration-300', 'ease-in-out');

      this.handleScroll();
    }

    setMenuOpen = (value) => {
      this.menuOpen = value;
      this.menuButton.classList.toggle('is-active', value);
      this.querySelector('#mobile-menu').setAttribute('aria-hidden', !value);
      this.querySelector('#mobile-menu-toggle').setAttribute('aria-expanded', value);

      gsap.to(this.headerBg, {
        ease: 'power4.inOut',
        duration: 0.5,
        delay: value ? 0 : window.scrollY >= this.height ? 0 : 1,
        y: value ? '-100%' : '0%',
      });

      gsap.to(this.logoMobile, {
        ease: 'power4.inOut',
        duration: 0.5,
        delay: value ? 0 : 1,
        y: value ? '-300%' : '0%',
      });

      gsap.to(this.menuLogo, {
        ease: 'power4.inOut',
        duration: 0.5,
        delay: value ? 1 : 0.25,
        y: value ? '0%' : '100%',
      });

      gsap.to(this.mobileMenu, {
        ease: 'power4.inOut',
        duration: 0.75,
        delay: value ? 0.5 : 0.5,
        y: value ? '0%' : '-100%',
      });

      if (value) {
        window.lenis.stop();
      } else {
        window.lenis.start();
      }
    };

    applyScrolledStyles = () => {
      this.headerBg.style.transform = `translate(-2px, 0px)`;
    };

    removeScrolledStyles = () => {
      this.headerBg.style.transform = `translate(-2px, -100%)`;
    };

    handleScroll() {
      if (window.scrollY >= this.height) {
        this.applyScrolledStyles();
      } else {
        this.removeScrolledStyles();
      }
    }

    connectedCallback() {
      window.addEventListener('scroll', () => {
        this.handleScroll();
      });

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.setMenuOpen(false);
        }
      });

      this.menuButton.addEventListener('click', () => {
        this.setMenuOpen(!this.menuOpen);
      });
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-accordion"] && !Shopify.designMode) return;
  try {
    
  class FAQAccordion extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('faq-accordion', FAQAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-all-reviews"] && !Shopify.designMode) return;
  try {
    
  class AllReviews extends HTMLElement {
    constructor() {
      super();
      this.page = 0;
      this.pageSize = 5;
      this.rawReviewsData = document.querySelector('#reviews-data').textContent;
      this.reviewsData = this.rawReviewsData ? JSON.parse(this.rawReviewsData) : {};
      this.reviewsContainer = this.querySelector('#customer-reviews');
      this.moreButton = this.querySelector('#view-more');
    }

    updateStars(scope, score) {
      const starsContainer = scope.querySelector('.review-stars');
      const stars = starsContainer.querySelectorAll('.star');
      const halfStar = starsContainer.querySelector('.star-half');

      let fullStars = Math.floor(score);
      let hasHalfStar = score % 1 >= 0.75 ? 1 : 0;

      // Round up from 0.75
      if (hasHalfStar) {
        fullStars += 1;
        halfStar.classList.add('hidden');
      } else if (score % 1 >= 0.25) {
        halfStar.classList.remove('hidden');
      } else {
        halfStar.classList.add('hidden');
      }

      // Update full stars
      stars.forEach((star, index) => {
        if (index < fullStars) {
          star.classList.remove('hidden');
        } else {
          star.classList.add('hidden');
        }
      });
    }

    appendReviews(reviews) {
      reviews.forEach((review) => {
        const reviewsTemplate = document.querySelector('#review-template').content.cloneNode(true);
        reviewsTemplate.querySelector('.review-name').textContent = review.authorName;
        this.updateStars(reviewsTemplate, review.rating);
        reviewsTemplate.querySelector('.review-time').textContent = review.relativeTimeDescription;
        reviewsTemplate.querySelector('.review-headline').textContent = review.headline;
        reviewsTemplate.querySelector('.review-text').textContent = review.text;
        reviewsTemplate.querySelector('.review-product').textContent = `REVIEW LEFT ON: ${this.reviewsData.name}`;

        this.reviewsContainer.appendChild(reviewsTemplate);
      });
    }

    handleViewMore() {
      this.page += this.pageSize;
      this.appendReviews(this.reviewsData.reviews.slice(this.page, this.page + this.pageSize));

      if (this.page + this.pageSize >= this.reviewsData.reviews.length) {
        this.moreButton.classList.add('hidden');
      }
    }

    connectedCallback() {
      if (!this.reviewsData || !this.reviewsData.reviews) {
        this.remove();
        return null;
      }
      this.querySelector('#view-more').addEventListener('click', this.handleViewMore.bind(this));
      this.appendReviews(this.reviewsData.reviews.slice(this.page, this.pageSize));
    }

    disconnectedCallback() {
      this.querySelector('#view-more').removeEventListener('click', this.handleViewMore.bind(this));
    }
  }

  customElements.define('all-reviews', AllReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-grid"] && !Shopify.designMode) return;
  try {
    
  class CollectionGrid extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('collection-grid', CollectionGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact-form"] && !Shopify.designMode) return;
  try {
    
  class ContactForm extends HTMLElement {
    constructor() {
      super();
      this.message = this.querySelector('.form-message');
      this.success = this.querySelector('.form-success');
      this.error = this.querySelector('.form-error');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
    }

    connectedCallback() {
      const form = this.querySelector('form');

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const form = e.target;
        this.submitButton.disabled = true;
        this.submitButtonText.textContent = 'Loading';

        fetch('https://client-api.cementworks.io/v1/api/ithaca/zendesk/create-ticket', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(Object.fromEntries(new FormData(form))),
        })
          .then((response) => response.json())
          .then(() => {
            this.message.classList.remove('hidden');
            this.success.classList.remove('hidden');
            this.error.classList.add('hidden');

            window.lenis.scrollTo(this.message, { offset: -180, lock: true });

            const t = setTimeout(() => {
              this.message.classList.add('hidden');
              this.success.classList.add('hidden');
              this.error.classList.add('hidden');

              clearTimeout(t);
            }, 5000);
            form.reset();
          })
          .catch((error) => {
            this.message.classList.remove('hidden');
            this.error.classList.remove('hidden');
            this.success.classList.add('hidden');

            window.lenis.scrollTo(this.message, { offset: -180, lock: true });

            console.error('Error:', error);
          })
          .finally(() => {
            this.submitButton.disabled = false;
            this.submitButtonText.textContent = 'Submit';
          });
      });
    }
  }
  customElements.define('contact-form', ContactForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cta"] && !Shopify.designMode) return;
  try {
    
  class CallToActionSection extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('cta-section', CallToActionSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-featured-products"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProducts extends HTMLElement {
    //   constructor() {
    //     super();
    //   }
    //   connectedCallback() {
    //     const productBlocks = [...document.querySelectorAll('.featured-product__block')];
    //     productBlocks.forEach((el) => {
    //       const img = el.querySelector('img:first-of-type');
    //       gsap.to(img, {
    //         ease: 'power4.out',
    //         scale: 1,
    //         scrollTrigger: {
    //           trigger: el,
    //           start: '25% bottom',
    //           end: '75% bottom',
    //         },
    //       });
    //     });
    //   }
  }
  customElements.define('featured-products', FeaturedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-featured-recipes"] && !Shopify.designMode) return;
  try {
    
  class FeaturedRecipes extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('featured-recipes', FeaturedRecipes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-fifty-fifty-v2"] && !Shopify.designMode) return;
  try {
    
  class FiftyFifty extends HTMLElement {
    constructor() {
      super();
    }

    videoSupportedCheck() {
      const id = this.querySelector('section').getAttribute('id');

      if (!window.videoSupported) {
        const video = this.querySelector(`#${id} .video_block`);
        const image = this.querySelector(`#${id} .video_block_image`);
        if (video) {
          video.remove();
        }
        if (image) {
          image.classList.remove('hidden');
        }
      } else {
        const image = this.querySelector(`#${id} .video_block_image`);

        if (image) {
          image.remove();
        }
      }
    }
    connectedCallback() {
      this.videoSupportedCheck();
    }
  }
  customElements.define('fifty-fifty', FiftyFifty);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-fifty-fifty"] && !Shopify.designMode) return;
  try {
    
  class FiftyFifty extends HTMLElement {
    constructor() {
      super();
    }

    videoSupportedCheck() {
      const id = this.querySelector('section').getAttribute('id');

      if (!window.videoSupported) {
        const video = this.querySelector(`#${id} .video_block`);
        const image = this.querySelector(`#${id} .video_block_image`);
        if (video) {
          video.remove();
        }
        if (image) {
          image.classList.remove('hidden');
        }
      } else {
        const image = this.querySelector(`#${id} .video_block_image`);

        if (image) {
          image.remove();
        }
      }
    }

    connectedCallback() {
      this.videoSupportedCheck();
    }
  }
  customElements.define('fifty-fifty', FiftyFifty);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-fullscreen-media"] && !Shopify.designMode) return;
  try {
    
  class FullscreenMedia extends HTMLElement {
    constructor() {
      super();
    }
    videoSupportedCheck() {
      const id = this.querySelector('section').getAttribute('id');

      if (!window.videoSupported) {
        const video = this.querySelector(`#${id} .video_block`);
        const image = this.querySelector(`#${id} .video_block_image`);
        if (video) {
          video.remove();
        }
        if (image) {
          image.classList.remove('hidden');
        }
      } else {
        const image = this.querySelector(`#${id} .video_block_image`);

        if (image) {
          image.remove();
        }
      }
    }
    connectedCallback() {
      this.videoSupportedCheck();
    }
  }

  customElements.define('fullscreen-media', FullscreenMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-icon-row"] && !Shopify.designMode) return;
  try {
    
  class IconRow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {}
    connectedCallback() {}

    connectedCallback() {}
  }
  customElements.define('icon-row', IconRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-image-hero"] && !Shopify.designMode) return;
  try {
    
  class ImageHero extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('image-hero', ImageHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-marquee"] && !Shopify.designMode) return;
  try {
    
  class Marquee extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('marquee', Marquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-media"] && !Shopify.designMode) return;
  try {
    
  class MediaBanner extends HTMLElement {
    constructor() {
      super();
    }
    videoSupportedCheck() {
      const id = this.querySelector('section').getAttribute('id');

      if (!window.videoSupported) {
        const video = this.querySelector(`#${id} .video_block`);
        const image = this.querySelector(`#${id} .video_block_image`);
        if (video) {
          video.remove();
        }
        if (image) {
          image.classList.remove('hidden');
        }
      } else {
        const image = this.querySelector(`#${id} .video_block_image`);

        if (image) {
          image.remove();
        }
      }
    }

    connectedCallback() {
      this.videoSupportedCheck();
    }
  }

  customElements.define('media-banner', MediaBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-merch-product-hero"]) return;
  try {
    
  class ProductHero extends HTMLElement {
    constructor() {
      super();
      this.flavor = this.querySelector('#flavor');
      this.product_id = this.getAttribute('data-product-id');
      this.rawReviewsData = document.querySelector('#reviews-data').textContent;
      this.reviewsData = this.rawReviewsData ? JSON.parse(this.rawReviewsData) : {};
    }

    updateStars(score) {
      const starsContainer = this.querySelector('.review-stars');
      const stars = starsContainer.querySelectorAll('.star');
      const halfStar = starsContainer.querySelector('.star-half');

      let fullStars = Math.floor(score);
      let hasHalfStar = score % 1 >= 0.75 ? 1 : 0;

      // Round up from 0.75
      if (hasHalfStar) {
        fullStars += 1;
        halfStar.classList.add('hidden');
      } else if (score % 1 >= 0.25) {
        halfStar.classList.remove('hidden');
      } else {
        halfStar.classList.add('hidden');
      }

      // Update full stars
      stars.forEach((star, index) => {
        if (index < fullStars) {
          star.classList.remove('hidden');
        } else {
          star.classList.add('hidden');
        }
      });
      starsContainer.classList.remove('hidden');
    }

    connectedCallback() {
      const rating = this.querySelector('#product-rating');
      if (this.reviewsData?.rating) {
        const numReviewsString = this.querySelector('#product-num-reviews');
        this.updateStars(this.reviewsData.rating);
        numReviewsString.innerText = `(${this.reviewsData.reviewsNumber})`;
      } else {
        rating.remove();
      }

      this.flavor.addEventListener('change', () => {
        window.location.href = `/products/${this.flavor.value}`;
      });
    }
  }
  customElements.define('product-hero', ProductHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-newsletter-signup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterSignup extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const form = this.querySelector('form');
      const inputArea = this.querySelector('.input-area');

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const form = e.target;
        const action = form.getAttribute('action');
        e.submitter.setAttribute('disabled', true);

        $.ajax({
          type: 'POST',
          url: action,
          data: $(form).serialize(),
          cache: false,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          error: (error) => {
            console.error(error);
            const size = inputArea.getBoundingClientRect();
            let message = document.createElement('p');
            message.innerText = 'Whoops! Please try again';
            message.style.height = size.height + 'px';
            inputArea.innerHTML = '';
            message.classList.add(
              'flex',
              'items-center',
              'justify-center',
              'text-center',
              'text-[26px]',
              'font-sans',
              'mb-[12px]'
            );
            inputArea.appendChild(message);
          },
          success: (res) => {
            console.log(res);
            const size = inputArea.getBoundingClientRect();
            let message = document.createElement('p');
            message.innerText = 'Thanks!';
            message.style.height = size.height + 'px';
            inputArea.innerHTML = '';
            message.classList.add(
              'flex',
              'items-center',
              'justify-center',
              'text-center',
              'text-[26px]',
              'font-sans',
              'mb-[12px]'
            );
            inputArea.appendChild(message);
          },
        });
      });

      const img = this.querySelector('.image_block img');

      gsap.to(img, {
        ease: 'power4.out',
        scale: 1,
        scrollTrigger: {
          trigger: img,
          start: '25% bottom',
          end: '75% bottom',
        },
      });
    }
  }
  customElements.define('newsletter-signup', NewsletterSignup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      const container = this.querySelector('swiper-container');
      if (!container) return;

      // swiper-container initialises itself asynchronously; wait for it rather
      // than assuming it is ready (the old code read .swiper in the constructor).
      const waitForSwiper = (attempt = 0) => {
        if (container.swiper) {
          this.setup(container.swiper);
          return;
        }
        if (attempt > 120) return;
        requestAnimationFrame(() => waitForSwiper(attempt + 1));
      };

      waitForSwiper();
    }

    setup(swiper) {
      this.swiper = swiper;
      this.slides = Array.from(this.querySelectorAll('swiper-slide'));
      this.nextButton = this.querySelector('.swiper-button-next');
      this.prevButton = this.querySelector('.swiper-button-prev');
      this.productLink = this.querySelector('#product-carousel-link');

      this.onSlideChange = () => this.handleChange();
      this.onNext = () => this.swiper.slideNext();
      this.onPrev = () => this.swiper.slidePrev();

      this.swiper.on('slideChange', this.onSlideChange);

      this.slideHandlers = this.slides.map((slide) => {
        const handler = () => {
          if (typeof this.swiper.clickedIndex === 'number') {
            this.swiper.slideTo(this.swiper.clickedIndex);
          }
        };
        slide.addEventListener('click', handler);
        return { slide, handler };
      });

      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);

      this.handleChange();
    }

    // Keeps the CTA button pointed at the product currently centred.
    // Bails out cleanly when the section has no CTA button — throwing here used
    // to break Swiper's own slideChange handling and made dragging stutter.
    handleChange() {
      if (!this.swiper || !this.productLink || !this.slides) return;

      const currentSlide = this.slides[this.swiper.activeIndex];
      if (!currentSlide) return;

      const barcode = currentSlide.getAttribute('data-barcode');
      const handle = currentSlide.getAttribute('data-handle') || '';

      if (handle.includes('products')) {
        this.productLink.href = `/${handle}`;
      } else {
        this.productLink.href = `${handle}?PROD=${barcode}`;
      }
    }

    disconnectedCallback() {
      if (this.swiper && this.onSlideChange) {
        this.swiper.off('slideChange', this.onSlideChange);
      }
      if (this.nextButton && this.onNext) {
        this.nextButton.removeEventListener('click', this.onNext);
      }
      if (this.prevButton && this.onPrev) {
        this.prevButton.removeEventListener('click', this.onPrev);
      }
      if (this.slideHandlers) {
        this.slideHandlers.forEach(({ slide, handler }) => {
          slide.removeEventListener('click', handler);
        });
      }
    }
  }
  customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-hero"]) return;
  try {
    
  class ProductHero extends HTMLElement {
    constructor() {
      super();
      this.product_id = this.getAttribute('data-product-id');
    }

    updateStars(score) {
      const starsContainer = this.querySelector('.review-stars');
      const stars = starsContainer.querySelectorAll('.star');
      const halfStar = starsContainer.querySelector('.star-half');

      let fullStars = Math.floor(score);
      let hasHalfStar = score % 1 >= 0.75 ? 1 : 0;

      // Round up from 0.75
      if (hasHalfStar) {
        fullStars += 1;
        halfStar.classList.add('hidden');
      } else if (score % 1 >= 0.25) {
        halfStar.classList.remove('hidden');
      } else {
        halfStar.classList.add('hidden');
      }

      // Update full stars
      stars.forEach((star, index) => {
        if (index < fullStars) {
          star.classList.remove('hidden');
        } else {
          star.classList.add('hidden');
        }
      });
      starsContainer.classList.remove('hidden');
    }

    connectedCallback() {
      const rawReviewsData = document.querySelector('#reviews-data')?.textContent;
      const reviewsData = rawReviewsData ? JSON.parse(rawReviewsData) : {};

      const rating = this.querySelector('#product-rating');
      if (reviewsData?.rating) {
        const numReviewsString = this.querySelector('#product-num-reviews');
        this.updateStars(reviewsData.rating);
        numReviewsString.innerText = `(${reviewsData.reviewsNumber})`;
      } else if (rating) {
        rating.remove();
      }

      const flavor = this.querySelector('#flavor');
      if (flavor) {
        flavor.addEventListener('change', (e) => {
          window.location.href = `/products/${e.target.value}`;
        });
      }
    }
  }
  customElements.define('product-hero', ProductHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-reviews"] && !Shopify.designMode) return;
  try {
    
  class ProductReviews extends HTMLElement {
    constructor() {
      super();
      this.page = 0;
      this.pageSize = 5;
      this.rawReviewsData = document.querySelector('#reviews-data').textContent;
      this.reviewsData = this.rawReviewsData ? JSON.parse(this.rawReviewsData) : {};
      this.reviewsContainer = this.querySelector('#customer-reviews');
      this.moreButton = this.querySelector('#view-more');
    }

    updateStars(scope, score) {
      const starsContainer = scope.querySelector('.review-stars');
      const stars = starsContainer.querySelectorAll('.star');
      const halfStar = starsContainer.querySelector('.star-half');

      let fullStars = Math.floor(score);
      let hasHalfStar = score % 1 >= 0.75 ? 1 : 0;

      // Round up from 0.75
      if (hasHalfStar) {
        fullStars += 1;
        halfStar.classList.add('hidden');
      } else if (score % 1 >= 0.25) {
        halfStar.classList.remove('hidden');
      } else {
        halfStar.classList.add('hidden');
      }

      // Update full stars
      stars.forEach((star, index) => {
        if (index < fullStars) {
          star.classList.remove('hidden');
        } else {
          star.classList.add('hidden');
        }
      });
    }

    appendReviews(reviews) {
      reviews.forEach((review) => {
        const reviewsTemplate = document.querySelector('#review-template').content.cloneNode(true);
        reviewsTemplate.querySelector('.review-name').textContent = review.authorName;
        this.updateStars(reviewsTemplate, review.rating);
        reviewsTemplate.querySelector('.review-time').textContent = review.relativeTimeDescription;
        reviewsTemplate.querySelector('.review-headline').textContent = review.headline;
        reviewsTemplate.querySelector('.review-text').textContent = review.text;
        reviewsTemplate.querySelector('.review-product').textContent = `REVIEW LEFT ON: ${this.reviewsData.name}`;

        this.reviewsContainer.appendChild(reviewsTemplate);
      });
    }

    handleViewMore() {
      this.page += this.pageSize;
      this.appendReviews(this.reviewsData.reviews.slice(this.page, this.page + this.pageSize));

      if (this.page + this.pageSize >= this.reviewsData.reviews.length) {
        this.moreButton.classList.add('hidden');
      }
    }

    connectedCallback() {
      if (!this.reviewsData || !this.reviewsData.reviews) {
        this.remove();
        return null;
      }
      this.querySelector('#view-more').addEventListener('click', this.handleViewMore.bind(this));
      this.appendReviews(this.reviewsData.reviews.slice(this.page, this.pageSize));
    }

    disconnectedCallback() {
      this.querySelector('#view-more').removeEventListener('click', this.handleViewMore.bind(this));
    }
  }

  customElements.define('product-reviews', ProductReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipe-grid"] && !Shopify.designMode) return;
  try {
    
  class RecipeGrid extends HTMLElement {
    constructor() {
      super();
      numArticles: {
        {
          blog.articles.size;
        }
      }
      page: 1;
    }
  }
  customElements.define('recipe-grid', RecipeGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipes-carousel"] && !Shopify.designMode) return;
  try {
    
  class RecipesCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiper = this.querySelector('swiper-container').swiper;
      this.nextButton = this.querySelectorAll('.swiper-button-next');
      this.prevButton = this.querySelectorAll('.swiper-button-prev');

      this.nextButton.forEach((el) => {
        el.addEventListener('click', () => {
          this.swiper.slideNext();
        });
      });

      this.prevButton.forEach((el) => {
        el.addEventListener('click', () => {
          this.swiper.slidePrev();
        });
      });
    }

    disconnectedCallback() {
      this.swiper.destroy();
      this.nextButton.forEach((el) => {
        el.removeEventListener('click', () => {
          this.swiper.slideNext();
        });
      });
      this.prevButton.forEach((el) => {
        el.removeEventListener('click', () => {
          this.swiper.slidePrev();
        });
      });
    }
  }
  customElements.define('recipes-carousel', RecipesCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recommended-products"] && !Shopify.designMode) return;
  try {
    
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const productBlocks = [...document.querySelectorAll('.featured-product__block')];

      productBlocks.forEach((el) => {
        const img = el.querySelector('img:first-of-type');

        gsap.to(img, {
          ease: 'power4.out',
          scale: 1,
          scrollTrigger: {
            trigger: el,
            start: '25% bottom',
            end: '75% bottom',
          },
        });
      });
    }
  }
  customElements.define('recommended-products', RecommendedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recommended-recipes"] && !Shopify.designMode) return;
  try {
    
  class RecommendedRecipes extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const productBlocks = [...document.querySelectorAll('.featured-recipe__block')];
      productBlocks.forEach((el) => {
        const img = el.querySelector('img:first-of-type');

        gsap.to(img, {
          ease: 'power4.out',
          scale: 1,
          scrollTrigger: {
            trigger: el,
            start: '25% bottom',
            end: '75% bottom',
          },
        });
      });
    }
  }
  customElements.define('recommended-recipes', RecommendedRecipes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.swiper = this.querySelector('swiper-container').swiper;
      this.nextButton = this.querySelector('.swiper-button-next');
      this.prevButton = this.querySelector('.swiper-button-prev');

      this.nextButton.addEventListener('click', () => {
        this.swiper.slideNext();
      });

      this.prevButton.addEventListener('click', () => {
        this.swiper.slidePrev();
      });
    }

    disconnectedCallback() {
      this.swiper.destroy();
      this.nextButton.removeEventListener('click', () => {
        this.swiper.slideNext();
      });
      this.prevButton.removeEventListener('click', () => {
        this.swiper.slidePrev();
      });
    }
  }
  customElements.define('reviews-carousel', ReviewsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-simple-hero"] && !Shopify.designMode) return;
  try {
    
  class SimpleHero extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('simple-hero', SimpleHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-team-grid"] && !Shopify.designMode) return;
  try {
    
  class TeamGrid extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('team-grid', TeamGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video"] && !Shopify.designMode) return;
  try {
    
  class VideoHero extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('video-hero', VideoHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-video"]) return;
  try {
    
  class TestVideo extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const video = this.querySelector('video');

      if (video == false) {
        return null
      }

      video.play().catch(() => {
        publish('test-video:unsupported')
      }). finally(() => {
        publish('test-video:supported')
        video.remove();
      });
    }
  }

  customElements.define('test-video', TestVideo);

  } catch(e) { console.error(e); }
})();
})();
